var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[(_vm.preview && _vm.mode=='edit')?_c('PDFEditMode',{key:_vm.preview}):_vm._e(),(_vm.preview && _vm.mode=='view')?_c('PDFViewMode',{key:_vm.preview}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }